
import { createSlice } from '@reduxjs/toolkit';
const initialState = () => {
    return {
        reportCompanies:[],
        errors:[],
        latestReportDate: null,
        requestReportData:[],
        categoryId:null,
    };
  };

const vaptReportSlice = createSlice({
  name: 'vaptReport',
  initialState:initialState(),
  reducers: {
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setReportCompanies(state, action) {
        state.reportCompanies = action.payload;
      },
      setLatestReportDate(state, action) {
        state.latestReportDate = action.payload;
      },
      setCategoryId(state, action){
        state.categoryId = action.payload;
      },
      setRequestReportData(state, action){
        state.requestReportData = action.payload;
      }
  },
});

export const {
  setErrors,
  setReportCompanies, 
  setLatestReportDate,
  setCategoryId,
  setRequestReportData,
} = vaptReportSlice.actions;
export const vaptReport=vaptReportSlice.reducer;